import IntegrationActionContentGitHub from './view'

export { default as shouldShowAction } from './shouldShowAction'

export default IntegrationActionContentGitHub
